<script>
    import { getContext } from 'svelte';
    import InformationPopup from './InformationPopup.svelte';

    const { open } = getContext('simple-modal');
    const showInformation = () => open(InformationPopup, {});
</script>
<img src="/images/information.svg" alt="information icon" class="information-icon" on:click={showInformation}/>
<style>
</style>